// extracted by mini-css-extract-plugin
export default {"root":"_2RuJq","button":"_28Q-s"};